import getApiUrl from "../utils/getApiUrl";
import fetch from "../utils/mgFetch";

const getTenantActiveUsersBetweenDates = (
    token: string,
    backend: string,
    fromDate: string,
    toDate: string,
    tenantId: string,
) => {
    return fetch(
        `${getApiUrl(backend)}tenant_active_users_between_dates/${fromDate}/${toDate}/${tenantId}`,
        {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
};

export default getTenantActiveUsersBetweenDates;